import axios from "axios";
import store from "../store";

class Elements {
	async get_folder(folder, tags = false, filters, share = false) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/document/folder",
					{
						folder,
						tags,
						filters,
						share
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					var data = response.data;
					if (!data.documents)
						data.documents = [];
					data.documents.forEach((element) => {
						element.checkbox = false;
					});
					resolve(data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async path_folder(path, libelle = false, share = false) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/document/path_folder",
					{
						path,
						libelle,
						share
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data.folders);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async search_documents(folder, query, filters, share = false) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/document/search",
					{
						folder,
						query,
						filters,
						share
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async add(libelle, parent, type, share = false) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/document/add",
					{
						libelle,
						folder: parent,
						type,
						share
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async add_files(form_data) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/document/add_files",
					form_data,
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getFile(id, name, dowload = true, response_type = "blob", share = false, test_jwt = null) {
		let jwt = test_jwt || store.state.jwt;

		console.log("getFile " + dowload)

		var opts = {
			headers: {
				Authorization: "bearer " + jwt,
			},
			params: {share : share ? "1" : "0"}
		};

		if (response_type) opts.responseType = response_type;

		return axios
			.get(`${process.env.VUE_APP_SAAS_BACK}` + "/document/" + id, opts)
			.then((response) => {
				if (dowload) {
					const url = window.URL.createObjectURL(
						new Blob([response.data])
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", name);
					document.body.appendChild(link);
					link.click();
				} else return response.data;
			});
	}

	async getInfoFile(id, share = false, test_jwt = null) {
		let jwt = test_jwt || store.state.jwt;

		var opts = {
			headers: {
				Authorization: "bearer " + jwt,
			},
			params: {share : share ? "1" : "0"}
		};

		return new Promise(function (resolve, reject) {
			axios
			.get(`${process.env.VUE_APP_SAAS_BACK}` + "/document/info/" + id, opts)
			.then(function (response) {
				resolve(response.data.document);
			})
			.catch(function (error) {
				reject(error);
			});
		});
	}

	async getZip(list, dowload = true, response_type = "blob", share = false, options, zip_uid = null, onDownloadProgress = null) {
		let jwt = store.state.jwt;

		var opts = {
			headers: {
				Authorization: "bearer " + jwt,
			},
		};

		if (response_type) opts.responseType = response_type;
		if (onDownloadProgress) opts.onDownloadProgress = onDownloadProgress;

		return axios
			.post(
				`${process.env.VUE_APP_SAAS_BACK}` + "/document/zip",
				{ list, share, opts: options, zip_uid },
				opts
			)
			.then((response) => {
				console.log("response")
				if (dowload) {
					const url = window.URL.createObjectURL(
						new Blob([response.data])
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", "files.zip");
					document.body.appendChild(link);
					link.click();
					return null;
				} else return {data: response.data};
			})
			.catch(async function (error) {
				console.log(error)
				console.log(error.response.status);
				return JSON.parse(await error.response.data.text());
			  });
	}

    async update_all(list, options, tags, tags_operation) {
        let jwt = store.state.jwt;

        var opts = {
			headers: {
				Authorization: "bearer " + jwt,
			},
		};

        // console.log("Update all tags: ", tags);
        // deep copy of the list
        var newList = JSON.parse(JSON.stringify(list));
        // ! this has to match the database
        newList.forEach(doc => {
            delete doc.tags;
            delete doc.checkbox;
            delete doc.add_tag;
        });

		return axios
			.put(
				`${process.env.VUE_APP_SAAS_BACK}` + "/document/update/multiple",
				{ list: newList, opts: options, tags, tags_operation },
				opts
			)
			.then((response) => {
				console.log("response")
				return {data: response.data};
			})            
    }

	async update(id, public_file = null, tags = null, comment = null, share = false, extra_columns = null) {
		let jwt = store.state.jwt;

		var update = {
			share
		}

		if (public_file != null)
			update.public = public_file;

		if (tags)
			update.tags = tags;

		if (comment)
			update.comment = comment;

		if (extra_columns)
			update.extra_columns = extra_columns;

		return new Promise(function (resolve, reject) {
			axios
				.put(
					`${process.env.VUE_APP_SAAS_BACK}` + "/document/" + id,
					update,
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async deleteFile(id, share = false) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.delete(`${process.env.VUE_APP_SAAS_BACK}` + "/document/" + id, {
					headers: { Authorization: "Bearer " + jwt },
					params: {share : share ? "1" : "0"}
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async deleteFiles(list, options) {
		let jwt = store.state.jwt;

		var opts = {
			headers: {
				Authorization: "bearer " + jwt,
			},
		};

		return axios
			.post(
				`${process.env.VUE_APP_SAAS_BACK}` + "/document/delete",
				{ list, opts: options},
				opts
			)
			.then((response) => {
				console.log("response")
				return {data: response.data};
			})
	}

	async rename(document, new_folder, new_name, delete_if_empty, options = null) {
		let jwt = store.state.jwt;

		var opts = {
			headers: {
				Authorization: "bearer " + jwt,
			},
		};

		return axios
			.post(
				`${process.env.VUE_APP_SAAS_BACK}` + "/document/rename",
				{ document, new_folder, new_name, delete_if_empty, options },
				opts
			)
			.then((response) => {
				console.log("response")
				return {data: response.data};
			})
	}

	async transfer_hermes() {
		let jwt = store.state.jwt;
		return axios
			.post(
				`${process.env.VUE_APP_SAAS_BACK}` + "/document/transfer_hermes",
				{},
				{ headers: { Authorization: "Bearer " + jwt } }
			)
			.then(r => r.data);
	}
}

export default new Elements();
